export const setupPersistentBanner = () => {
    const persistentBanners = document.querySelectorAll('.persistent-banner');

    persistentBanners.forEach(banner => {
        const closeButton = banner.querySelector('.persistent-banner__close');
        closeButton?.addEventListener('click', () => {
            banner.classList.add('persistent-banner--hidden');
        });
    });  
}